import React, { FC } from 'react';

import { ComponentProps } from '../filterComponentConstructor';

const FilterInput: FC<ComponentProps> = () => {
  return <div>FilterInput</div>;
};

export default FilterInput;
